import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import "../index.css";

const Modal1 = () => {
  const [showModal1, setShowModal1] = useState(false);

  useEffect(() => {
    const timers = [];

    // Modal show schedule at 5s, 15s, 30s
    const scheduleTimes = [5000, 15000, 30000];

    scheduleTimes.forEach((delay) => {
      const timer = setTimeout(() => {
        setShowModal1(true); // Force modal open at each time
      }, delay);
      timers.push(timer);
    });

    // iOS-safe viewport height fix
    const setVhUnit = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    };

    setVhUnit();
    window.addEventListener("resize", setVhUnit);

    return () => {
      timers.forEach(clearTimeout);
      window.removeEventListener("resize", setVhUnit);
    };
  }, []);

  const closeModal1 = () => {
    setShowModal1(false);
  };

  return (
    <Modal
      className="offer-modal"
      show={showModal1}
      onHide={closeModal1}
      centered
      dialogClassName="custom-modal-dialog"
    >
      <Modal.Body className="custom-modal-body">
        <div className="offerr position-relative">
          <img
            src="images/closeSvg.svg"
            alt="Close"
            className="close-icon"
            onClick={closeModal1}
          />
          <img src="images/offer.jpeg" alt="Offer" className="offer-image" />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default Modal1;
